import { combineReducers } from "redux";

import { Assets, WellKnownAssets, AssetInfo, searchAssets } from "reducers/assets";
import { Accounts, AccountInfo } from "reducers/accounts";
import { Contacts } from "reducers/contacts";
import { Auth } from "reducers/auth";
import { Transactions } from "reducers/transactions";
import { AppPreferences } from "reducers/appPreferences";
import {
	FetchingDataFromApi,
	SendingTransaction,
	BuildingComponent,
	BuildingApp,
	UpdatingData,
	LiveSearchLoading,
	InputSwapQuoteLoading,
} from "reducers/loaders";
import { Profile } from "reducers/profile";
import { UserPreferences } from "reducers/userPreferences";
import { UserSettings } from "reducers/userSettings";
import { UserNotificationPreferences } from "reducers/userNotificationPreferences";
import { LocalUsers, DaffiUsers, RefreshAppData } from "reducers/users";
import { DeviceInfo } from "reducers/deviceInfo";
import secureLocalStorage from "react-secure-storage";
import { LOGOUT_USER } from "helpers/constants";

const appReducer = combineReducers({
	Assets,
	WellKnownAssets,
	AssetInfo,
	searchAssets,
	Accounts,
	Contacts,
	AccountInfo,
	Auth,
	Transactions,
	AppPreferences,
	FetchingDataFromApi,
	SendingTransaction,
	BuildingComponent,
	BuildingApp,
	UpdatingData,
	LiveSearchLoading,
	InputSwapQuoteLoading,
	Profile,
	UserPreferences,
	UserSettings,
	UserNotificationPreferences,
	LocalUsers,
	DaffiUsers,
	RefreshAppData,
	DeviceInfo,
});

export const RootReducers = (state, action) => {
	if (action.type === LOGOUT_USER) {
		secureLocalStorage.removeItem("currentUser");
		secureLocalStorage.removeItem("currentUserStatus");
		secureLocalStorage.removeItem("appPreferences");

		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};
